module.exports = __webpack_public_path__ + "img/resume.208d6e44.svg";